export class Tasks {
  taskId: string;
  taskName: string;
  requester: string;
  processInstanceId: string;
  assignee: string;
  taskCreatedTime: string;
  taskStatus: string;
  userName?: string;
  roleName?: string;
  delegationName?: string;
}

export interface ClientAuditTask {
  userDisplayName: string;
  userId: string;
  roleName: string;
  taskName: string;
}
